(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index-products-carousel-left"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function($) {
	$('.products_carousel_mod').each(function(i) {

		var sliderId = '#' + $(this).attr('id');
		var sliderVar = $(this).attr('id');
		var sliderPagination = '#pagination_' + sliderVar.replace('products_carousel_mod_', '');

		var carouselVar = new Swiper( sliderId, {
			effect: 'slide',
			slidesPerView: 2,
			spaceBetween: 30,
			speed: 500,
			autoplayDisableOnInteraction: false,
			breakpoints: {
				576: {
					slidesPerView: 2,
				},
				768: {
					slidesPerView: 2,
				},
				992: {
					slidesPerView: 2,
				},
				1200: {
					slidesPerView: 3,
				}
			},
			pagination: {
				el: sliderPagination,
				type: 'bullets',
				clickable: true
			}
		});

	});

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["universal-slideshow"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function ($) {
    $('.universal-slideshow.section_slideshow').each(function (i) {
      var sliderId = '#' + $(this).attr('id');
      var sliderVar = $(this).attr('id');
      var sliderPagination = '#pagination_' + sliderVar.replace('slideshow_', '');
      var sliderPrev = '#slider_prev_' + sliderVar.replace('slideshow_', '');
      var sliderNext = '#slider_next_' + sliderVar.replace('slideshow_', '');
      var sliderEffect = $(this).data('effect');
      var sliderPagType = $(this).data('pagination');
      var sliderAutoplay = $(this).data('autoplay');
      var sliderDelayAutoplay = $(this).data('delay');
      var sliderSpeed = $(this).data('speed');

      var settings = {
        effect: sliderEffect,
        speed: sliderSpeed,
        autoHeight: true,
        loop: false,
        pagination: {
          el: sliderPagination,
          clickable: true,
          dynamicBullets: false,
        },
        on: {
          slideChangeTransitionStart: function () {
            AOS.refresh(true);
          },
          slideChangeTransitionEnd: function () {
            AOS.init();
          },
        },
        navigation: {
          nextEl: sliderNext,
          prevEl: sliderPrev,
        },
      };

      if (sliderAutoplay == true) {
        settings.autoplay = { delay: sliderDelayAutoplay };
      }

      if (sliderPagType == 'bullets') {
        settings.pagination.type = 'bullets';
        settings.pagination.clickable = true;
      } else if (sliderPagType == 'dynamicBullets') {
        settings.pagination.dynamicBullets = true;
        settings.pagination.clickable = true;
      } else if (sliderPagType == 'progressbar') {
        settings.pagination.type = 'progressbar';
      } else if (sliderPagType == 'fraction') {
        settings.pagination.type = 'fraction';
      } else if (sliderPagType == 'navigation') {
        settings.pagination.type = false;
      } else {
        settings.pagination.type = 'bullets';
        settings.pagination.clickable = true;
      }

      var sliderVar = new Swiper(sliderId, settings);

      $(window).on('resize', function () {
        sliderVar.updateSize(); // updating swiper after loading
      });

      sliderVar.on('init', function (el) {
        var currentSlideIndex = sliderVar.activeIndex;
        var currentSlide = sliderVar.slides[currentSlideIndex];
        var ytPlayer = currentSlide.querySelector('iframe');
        if (ytPlayer) {
          ytPlayer.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        }
      });

      /* Youtube Player event slide (next or previous) */
      sliderVar.on('slideChange', function (el) {
        $('.slide_video').each(function (i) {
          var ytPlayer = $(this).find('iframe').get(0);
          if (ytPlayer) {
            ytPlayer.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
          }
        });
        var currentSlideIndex = sliderVar.realIndex;
        var currentSlide = sliderVar.slides[currentSlideIndex];
        var ytPlayer = currentSlide.querySelector('iframe');
        if (ytPlayer) {
          ytPlayer.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        }
      });

      /* Init Youtube Player */

      $(this)
        .find('.player-js')
        .each(function (i) {
          var slVideoId = '#' + $(this).attr('id');
          $(slVideoId).YTPlayer(i);
        });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
